export const locales = ['de', 'en'] as const;
export type Locale = (typeof locales)[number];
export const defaultLocale: Locale = 'de';

export const localeToIntl: Record<Locale, string> = {
    de: 'de-DE',
    en: 'en-US',
};
